import styled from '@emotion/styled';
import { TableRow } from '@mui/material';

export default styled(TableRow)`
  >td:first-of-type {
    padding: 0 0 6px 0;
  }
`;
